import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';

export const selectInheritedIraState = createSelector(
  fromFeature.getInheritedIraState,
  (state) => state,
);

export const selectInheritedIraDecedentName = createSelector(
  selectInheritedIraState,
  (state) => state.decedentName,
);
